import { useQueryClient } from "@tanstack/react-query";
import { useAtom, useSetAtom } from "jotai";
import {
  accessTokenAtom,
  accountsAtom,
  currentAccountIdAtom,
  currentWorkspaceIdAtom,
  organizationsAtom,
  partnershipWorkspacesAtom,
  refreshTokenAtom,
  workspacesAtom,
} from "@/store";

export const useAuth = () => {
  const [accessToken, setAccessToken] = useAtom(accessTokenAtom);
  const setRefreshToken = useSetAtom(refreshTokenAtom);
  const setAccounts = useSetAtom(accountsAtom);
  const setCurrentAccountId = useSetAtom(currentAccountIdAtom);
  const setWorkspaces = useSetAtom(workspacesAtom);
  const setOrganizations = useSetAtom(organizationsAtom);
  const setPartnershipWorkspaces = useSetAtom(partnershipWorkspacesAtom);
  const setCurrentWorkspaceId = useSetAtom(currentWorkspaceIdAtom);

  const queryClient = useQueryClient();
  const isAuthenticated = !!accessToken;

  const disconnect = () => {
    setAccessToken("");
    setRefreshToken("");
    setCurrentAccountId("");
    setCurrentWorkspaceId("");
    setAccounts([]);
    setWorkspaces([]);
    setOrganizations([]);
    setPartnershipWorkspaces([]);
    queryClient.clear();
  };

  return {
    isAuthenticated,
    disconnect,
  };
};
